// extracted by mini-css-extract-plugin
export var banner = "InviteYourFriendsBannerMobile-module__banner___nEEak";
export var content = "InviteYourFriendsBannerMobile-module__content___wOsfv";
export var iconAndText = "InviteYourFriendsBannerMobile-module__iconAndText___jmqgv";
export var subtitle = "InviteYourFriendsBannerMobile-module__subtitle___GOuG8";
export var text = "InviteYourFriendsBannerMobile-module__text___Ppqs1";
export var texture = "InviteYourFriendsBannerMobile-module__texture___tjwY7";
export var title = "InviteYourFriendsBannerMobile-module__title___8wfY4";